import { Button } from '@/components/ui';
import { Dialog } from '@/components/ui/dialog';

type ProactiveAgentDeleteDialogProps = {
  agent: string;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ProactiveAgentDeleteDialog = ({
  agent,
  isPending,
  onClose,
  onConfirm,
}: ProactiveAgentDeleteDialogProps) => (
  <Dialog.Root
    open
    onOpenChange={(open) => {
      if (!open && !isPending) onClose();
    }}
  >
    <Dialog.Content>
      <Dialog.Header>
        <Dialog.Title>Delete agent?</Dialog.Title>
        <Dialog.Description className="break-words">
          Remove {agent}, together with its chat, its routines and their run
          history, and the action cards those routines produced. Other agents
          are unchanged. This cannot be undone.
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.Footer>
        <Button variant="secondary" disabled={isPending} onClick={onClose}>
          Cancel
        </Button>
        <Button variant="destructive" disabled={isPending} onClick={onConfirm}>
          {isPending ? 'Deleting...' : 'Delete agent'}
        </Button>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Root>
);
